// assets/multi-buy-table.js

// ─────────────────────────────────────────────────────────────────────────────
// Fallback for Shopify.formatMoney
// ─────────────────────────────────────────────────────────────────────────────
window.Shopify = window.Shopify || {};
if (typeof Shopify.formatMoney !== 'function') {
  Shopify.formatMoney = (cents, formatString) =>
    formatString.replace(/{{.*?}}/, (cents / 100).toFixed(2));
}



let totalItems = 0;
let totalCost  = 0;

// ─────────────────────────────────────────────────────────────────────────────
// Recalculate totals & update Add button + Clear-All link
// ─────────────────────────────────────────────────────────────────────────────
function updateTotals(input) {
  const quantity    = parseInt(input.value, 10) || 0;
  const price       = parseFloat(input.getAttribute('data-variant-price'));
  const oldQuantity = parseInt(input.getAttribute('data-old-quantity'), 10) || 0;

  totalItems = totalItems - oldQuantity + quantity;
  totalCost  = totalCost - (oldQuantity * price) + (quantity * price);
  input.setAttribute('data-old-quantity', quantity);

  const priceFormatted = Shopify.formatMoney(totalCost, Shopify.money_format);
  const btnText  = document.querySelector('.js-quick-multibuy-submit .button-text');
  const priceEl  = document.querySelector('.js-quick-multibuy-submit-price');
  const clearAll = document.getElementById('clearAll');

  if (totalItems > 0) {
// singular vs. plural, using your dynamic templates
const tpl = totalItems === 1
  ? window.__.addSingleItemToCartTpl
  : window.__.addMultipleItemsToCartTpl;
btnText.innerText = tpl.replace('{{count}}', totalItems);
    priceEl.classList.remove('hidden');
    priceEl.innerText = `– ${priceFormatted}`;
    clearAll?.classList.remove('hidden');
  } else {
btnText.innerText = window.__.addToCartLabel;
    priceEl.classList.add('hidden');
    priceEl.innerText = '';
    clearAll?.classList.add('hidden');
  }

  document.querySelector('.js-quick-multibuy-submit')
    .toggleAttribute('disabled', totalItems === 0);
}

// ─────────────────────────────────────────────────────────────────────────────
// Reset the matrix back to zeros (empty inputs + placeholder)
// ─────────────────────────────────────────────────────────────────────────────
function clearMatrix() {
  document.querySelectorAll('.js-quantity-selector__value').forEach(input => {
    if (!input.disabled) {
      input.value = '';
      input.setAttribute('data-old-quantity', 0);
    }
  });

  totalItems = 0;
  totalCost  = 0;

  const btnText = document.querySelector('.js-quick-multibuy-submit .button-text');
  const priceEl = document.querySelector('.js-quick-multibuy-submit-price');
btnText.innerText = window.__.addToCartLabel;
  priceEl.innerText = '';
  priceEl.classList.add('hidden');
  document.querySelector('.js-quick-multibuy-submit').setAttribute('disabled', true);

  document.getElementById('clearAll')?.classList.add('hidden');
}

// ─────────────────────────────────────────────────────────────────────────────
// Update the header text (prompt or price) based on any nonzero quantity
// ─────────────────────────────────────────────────────────────────────────────
function updateVariantPriceHeader() {
  const headerEl       = document.getElementById('variant-price-header');
  const quantityInputs = document.querySelectorAll('.js-quantity-selector__value');
  let found = false;

  quantityInputs.forEach(input => {
    const qty = parseInt(input.value, 10);
    if (qty > 0 && !found) {
      const cell  = input.closest('[data-price]');
      const price = cell?.getAttribute('data-price');
      if (price) {
headerEl.textContent = window.__.pricePerItemLabel + ' ' 
  + Shopify.formatMoney(parseFloat(price), Shopify.money_format);
        found = true;
      }
    }
  });

  if (!found && headerEl) {
    headerEl.textContent = 'Fill in your desired quantities in the table below';
  }
}

// ─────────────────────────────────────────────────────────────────────────────
// Main entrypoint: only run if our multi-buy wrapper exists
// ─────────────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.js-quickbuy-wrapper');
  if (!wrapper) return;

  // Scope all selectors inside the multi-buy wrapper
  const inputs    = wrapper.querySelectorAll('.js-quantity-selector__value');
  const clearAll  = document.getElementById('clearAll');                  // global link
  const promptEl  = document.getElementById('qb-prompt');                 // header span
  const priceEl   = document.getElementById('qb-price');                  // header span
  const submitBtn = wrapper.querySelector('.js-quick-multibuy-submit');    // add 
  const btnText = submitBtn.querySelector('.button-text');
  if (btnText) btnText.innerText = window.__.addToCartLabel;
  submitBtn.setAttribute('disabled', true);

  // 1) Bind Clear All link
  clearAll?.addEventListener('click', e => {
    e.preventDefault();
    clearMatrix();
    updateVariantPriceHeader();
  });

  // 2) Initialize & bind each input
  inputs.forEach(input => {
    if (input.disabled) return;

    // Start blank with ghost-zero
    input.value           = '';
    input.placeholder     = '0';
    input.setAttribute('data-old-quantity', 0);

    // Block non-digit keystrokes
    input.addEventListener('keydown', function(e) {
      const navKeys = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab'];
      if (!/^[0-9]$/.test(e.key) && !navKeys.includes(e.key)) {
        e.preventDefault();
      }
    });

    // Strip any non-digits & recalc
    input.addEventListener('input', function() {
      this.value = this.value.replace(/\D/g,'');
      updateTotals(this);
      updateVariantPriceHeader();
    });

    // Also on change (for non-mobile)
    input.addEventListener('change', () => {
      updateTotals(input);
      updateVariantPriceHeader();
    });
  });

// 3) On load, compute & show static price pill
if (inputs.length) {
  const p = inputs[0].dataset.variantPrice;
  priceEl.classList.remove('hidden');
  priceEl.textContent = window.__.pricePerItemLabel + ' ' 
    + Shopify.formatMoney(parseFloat(p), Shopify.money_format);
}


  // 4) SKU switcher: clicking any swatch cell updates SKU header
  wrapper.addEventListener('click', e => {
    const cell = e.target.closest('[data-variant-sku]');
    if (cell && !cell.classList.contains('quantity-popover-container--disabled')) {
      document.querySelector('.product-meta__sku-number').textContent =
        cell.dataset.variantSku;
    }
  });

  // 5) Bulk Add-to-Cart binding
  const handler = function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const items = Array.from(wrapper.querySelectorAll('.js-quantity-selector__value'))
      .map(input => {
        const id  = input.getAttribute('data-variant-id');
        const qty = parseInt(input.value, 10);
        return id && qty ? { id, quantity: qty } : null;
      })
      .filter(Boolean);

    if (items.length === 0) return;

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ items })
    })
    .then(() => {
      clearMatrix();
      updateCartCount();
      updateMiniCart();
      document.querySelector('.header__cart-toggle')?.click();
    })
    .catch(console.error);
  };
  ['touchend','click'].forEach(evt =>
    submitBtn?.addEventListener(evt, handler, { capture: true })
  );

  // 6) Initial header update
  updateVariantPriceHeader();
});

// ─────────────────────────────────────────────────────────────────────────────
// Helpers for mini-cart and cart count
// ─────────────────────────────────────────────────────────────────────────────
function updateMiniCart() {
  fetch('/?sections=mini-cart')
    .then(res => res.text())
    .then(text => {
      const parsed = JSON.parse(text);
      document.querySelector('#mini-cart').innerHTML = parsed['mini-cart'];
    });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(data => {
      const countEl = document.querySelector('#cart-icon-bubble .header__cart-count');
      if (countEl) countEl.innerText = data.item_count;
    });
}
